/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { trackingCustomize } from "../../../../stores/actions/tracking.actions.types";

const CUSTOMIZE_TYPE_VALUES = ["customize", "customize_builder", "custom_wheel_2026"];

const EVENT_TYPE_LABELS = {
  customize: "Product",
  customize_builder: "Builder",
  custom_wheel_2026: "Custom Wheel",
};

const Customize = (props) => {
  const [leads, setLeads] = useState([]);
  const [breakdown, setBreakdown] = useState([]);

  useEffect(() => {
    const params = { ...props.dateParams };
    if (props.source && CUSTOMIZE_TYPE_VALUES.includes(props.source)) {
      params.type = props.source;
    } else if (props.source) {
      params.source = props.source;
    }
    props.trackingCustomize({
      data: params,
      callback: (data) => {
        if (data.success) {
          setLeads(data.data.data || []);
          setBreakdown(data.data.breakdown || []);
        }
      },
    });
  }, [props.dateParams, props.source]);

  if (props.loading) {
    return (
      <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
        <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
      </div>
    );
  }

  if (!leads?.length) {
    return (
      <div className='flex dark:bg-boxdark rounded bg-white items-center justify-center min-h-96'>
        <p className='text-xl text-center text-primary'>No Customize Leads Found</p>
      </div>
    );
  }

  return (
    <div className='rounded-[10px] bg-white border border-stroke p-4 dark:bg-boxdark'>
      {breakdown.length > 0 && (
        <div className='flex flex-wrap gap-3 mb-4'>
          {breakdown.map((item) => (
            <span
              key={item.eventType}
              className='inline-flex items-center gap-1.5 rounded-full border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 px-3 py-1 text-xs'
            >
              <span className='font-medium text-gray-700 dark:text-gray-300'>
                {EVENT_TYPE_LABELS[item.eventType] || item.eventType}:
              </span>
              <span className='font-semibold text-gray-900 dark:text-white'>{item.total}</span>
              <span className='text-gray-400 dark:text-gray-500'>
                ({item.uniqueUserCount} unique)
              </span>
            </span>
          ))}
        </div>
      )}
      <div className='max-w-full overflow-x-auto'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left'>
              <th className='min-w-[180px] px-4 py-2 font-medium text-sm'>Email</th>
              <th className='min-w-[140px] px-4 py-2 font-medium text-sm'>Phone</th>
              <th className='w-[500px] px-4 py-2 font-medium text-sm'>Items</th>
              <th className='min-w-[160px] px-4 py-2 font-medium text-sm'>YMM</th>
              <th className='min-w-[160px] px-4 py-2 font-medium text-sm'>Last Activity</th>
              <th className='min-w-[200px] px-4 py-2 font-medium text-sm'>Session ID</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((item, index) => (
              <tr key={index} className='text-sm'>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {item.email || <span className='text-gray-400'>—</span>}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {item.phone || <span className='text-gray-400'>—</span>}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  <div className='grid grid-cols-2 gap-2 w-[480px]'>
                    {item.items?.map((product, i) => (
                      <div
                        key={i}
                        className='rounded-lg border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 p-2.5 text-xs flex flex-col gap-1.5'
                      >
                        {product.title && (
                          <a
                            href={product.productUrl}
                            target='_blank'
                            rel='noreferrer'
                            className='font-semibold text-gray-800 dark:text-gray-100 leading-tight line-clamp-2 hover:text-red-500 hover:underline'
                          >
                            {product.title}
                          </a>
                        )}
                        {product.eventType && (
                          <span className='inline-flex w-fit items-center rounded bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300 px-2 py-0.5 font-medium'>
                            {EVENT_TYPE_LABELS[product.eventType] || product.eventType}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark text-xs'>
                  {item.ymmData ? (
                    <span>
                      {[item.ymmData.year, item.ymmData.make, item.ymmData.model]
                        .filter(Boolean)
                        .join(" ") || <span className='text-gray-400'>—</span>}
                    </span>
                  ) : (
                    <span className='text-gray-400'>—</span>
                  )}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark'>
                  {item.lastActivity ? new Date(item.lastActivity).toLocaleString() : <span className='text-gray-400'>—</span>}
                </td>
                <td className='border-b px-4 py-2 dark:border-strokedark font-mono text-xs truncate max-w-[200px]'>
                  {item.sessionId || <span className='text-gray-400'>—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { trackingCustomize })(Customize);
